<template>
  <div class="container">
    <div v-for="(item, index) in temps" :key="index" class="module-container" v-if="!isLogin">
      <div class="line-title headline module-title">
        <span>{{ item.name }}</span>
        <div class="more-template" @click="moreTemplate">更多模板</div>
      </div>
      <div class="out-container">
        <cube-scroll :ref="`scroll${index}`" :data="item.temps" direction="horizontal"
                     class="horizontal-scroll-list-wrap" :options="{eventPassthrough: 'vertical', click: false}">
          <div class="temp-wrapper list-wrapper">
            <div v-for="(val, index) in item.temps" class="temp-content list-item" :key="index" @click="useTemp(val)">
              <div class="temp-img-container flex-center">
                <img v-lazy="val.cn_img || val.en_img" alt="">
              </div>
              <p class="temp-name">{{ val.cn }}</p>
              <p>
                <span class="temp-tag" v-for="(tag, index) in val.tags" :key="index">{{ tag.cn }}</span>
              </p>
            </div>
          </div>
        </cube-scroll>
      </div>
    </div>
    <div class="module-container flex-column temp-example" v-if="cvList.length === 0">
      <div class="flex-between">
        <div>
          <p class="headline line-title daniu">大牛简历</p>
<!--          <p class="module-desc">HR 推荐的专业简历模板</p>-->
        </div>
        <div class="flex-center">
          <div class="more" @click.stop="toTemplates">
            <div class="more-template">更多模板</div>
          </div>
<!--          <span class="iconfont iconchevron-right"/>-->
        </div>
      </div>
      <div class="template-tags flex-start">
        <div class="template-tag" v-for="(item, index) in tags" :key="index"
           @click.stop="moreCategoryTemplates(item)">{{ item.cn }}</div>
      </div>
      <div class="cv-templates flex">
        <div class="cv-template" v-for="(temp, index) in templateCase" @click="useTemp(temp)" :key="index">
          <div class="temp-img-wrapper flex-center">
            <img v-lazy="temp.img" alt="">
          </div>
          <p class="template-name">{{ temp.name }}</p>
        </div>
      </div>
      <div class="more-btn flex-center" @click="toTemplates">更多简历模板</div>
    </div>
  </div>
</template>

<script>
import { temps, recommendTemps } from '@/assets/json/temps'
import {mapState} from "vuex";
export default {
  name: "CvTemplates",
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    templateCase: {
      type: [Object, Array],
      default: []
    },
    tags: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      temps
    }
  },
  computed: {
    ...mapState('cvIndex', [ 'cvList' ]),
  },
  methods: {
    useTemp(val) {
      this.$emit('useTemp', val, 'daniu')
    },
    moreTemplate() {
      this.$fn.jump(`${window.location.origin}/cvs/templates`, () => {
        this.$router.push('/cvs/templates')
      })
    },
    toTemplates() {
      this.$fn.jump(`${window.location.origin}/jianlimoban/tuijian/`)
    },
    moreCategoryTemplates(item) {
      this.$fn.jump(`${window.location.origin}/jianlimoban/${item.en}/`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global/variable';
@import '@/assets/scss/global/mixin';

.more-template {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 76px;
  height: 24px;
  border-radius: 12px;
  border: 1px solid #ececec;
  font-size: 13px;
  color: #606060;
}

.container {
  background-color: #f9f9f9;
  .out-container {
    position: relative;
    left: -24px;
    width: 100vw;
    margin-top: 12px;
    /deep/ .cube-scroll-content {
      display: inline-block;
    }
    .temp-wrapper {
      padding: 8px 0;
      white-space: nowrap;
      .temp-content {
        display: inline-block;
        width: 130px;
        margin-right: 18px;
        &:first-child {
          margin-left: 24px;
        }
        &:last-child {
          margin-right: 24px;
        }
        .temp-img-container {
          width: 134px;
          height: 174px;
          padding: 14px 12px 12px 8px;
          border-radius: 4px;
          border: 1px solid #f0f0f0;
          margin-bottom: 12px;
          img[lazy=loading] {
            width: 64px;
          }
          img {
            width: 110px;
          }
        }
        .temp-name {
          font-weight: 500;
          line-height: 20px;
          margin-bottom: 8px;
        }
        .temp-tag {
          display: inline-block;
          padding: 4px 10px;
          background-color: #f7f7f7;
          border-radius: 2px;
          font-size: $font-size-small;
          color: #9c9c9c;
          line-height: 12px;
          margin-right: 6px;
        }
      }
    }
  }
  .module-container {
    background-color: $color-light;
    padding: 24px 24px 24px;
    margin-bottom: 12px;

    .more-btn {
      border-radius: 21px;
      background-color: #f9f9f9;
      width: px2rem(280px);
      height: px2rem(42px);
      color: $color-dark-gray;
      font-size: $font-size-medium;
      margin: 12px auto 0;
      font-weight: 400;
    }

    &:first-child {
      padding-top: 0;
    }
    .template-tags {
      padding: 16px 0 8px;
      overflow: hidden;
      .template-tag {
        display: inline-block;
        padding: 5px 10px;
        margin-right: 10px;
        border-radius: 12px;
        border: 1px solid #f0f0f0;
        color: #9c9c9c;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .cv-templates {
      flex-wrap: wrap;
      justify-content: space-between;
      .cv-template {
        margin-top: 16px;
        .temp-img-wrapper {
          width: 92px;
          height: 118px;
          border-radius: 4px;
          border: 1px solid #f0f0f0;
          margin-bottom: 12px;
          img[lazy=loading] {
            width: 36px;
          }
          img {
            width: 82px;
          }
        }
        .template-name {
          width: 92px;
          text-align: center;
          font-size: $font-size-small;
          line-height: 20px;
          color: $color-title;
        }
      }
    }
  }
  .line-title {
    font-size: 18px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-weight: 500;
    }
    //&::before {
    //  content: '';
    //  display: inline-block;
    //  width: 2px;
    //  height: 12px;
    //  background-color: $color-theme;
    //  border-radius: 1px;
    //  margin-right: 8px;
    //}
  }
  .temp-example {
    margin-bottom: 0;
    padding-bottom: 35px;
  }
}
</style>